export enum PicUp_Component {
  MyActions = "myactions",
  ActionAssignedByUser = "asctionassignedbyuser",
  SLAReviewAction = "slareviewaction",
}
